import { BaseContainerModel } from '../base-container.model';
import { bl_mrp_prodsys_process_type_file_RowClass } from '../../dbschema/bl_mrp_prodsys_process_type_file.model';

export class ProdsysProcessTypeFileContainerModel extends BaseContainerModel {
  bl_mrp_prodsys_process_type_file: bl_mrp_prodsys_process_type_file_RowClass = new bl_mrp_prodsys_process_type_file_RowClass();
}
